// extracted by mini-css-extract-plugin
export default {"body":"DevelopTemplateCreation_body__KpHTU","subtitle":"DevelopTemplateCreation_subtitle__higPO","placeholder":"DevelopTemplateCreation_placeholder__Ti4J+"};